

































































































































import {Component, Prop, Emit, Vue} from 'vue-property-decorator';
import ChargeApi from "@/consoleapi/api/charge";

@Component
export default class RegisterInput extends Vue {
    private creditCardName = '';
    private creditCardNumber = '';
    private creditCardExpirationYear = '';
    private creditCardExpirationMonth = '';

    @Prop() phoneNumber!: string;
    @Prop() mailaAddress!: string;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    public pushCheck() {
        if (!this.validation()) {
            return;
        }
        this.registCreditCard();
    }

    private registCreditCard(){
        this.accountId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID));
        const chargeApi = new ChargeApi();
        chargeApi.setBearerToken(this.bearerToken);
        chargeApi.post(this.accountId, this.creditCardNumber, this.creditCardExpirationYear, this.creditCardExpirationMonth, this.creditCardName, this.phoneNumber, this.mailaAddress).then(() => {
            this.$router.replace('/register/done');
        }).catch(error => {
            //console.log(error.response);
            alert('クレジットカードの登録に失敗しました。');
            return;
        });
    }

    validation() {
        if (!this.creditCardName) {
            alert('クレジットカード名義を入力してください。');
            return false;
        }
        if (!this.creditCardNumber) {
            alert('クレジットカード番号を入力してください。');
            return false;
        }
        if (!this.creditCardExpirationYear) {
            alert('有効期限年を指定してください。');
            return false;
        }
        if (!this.creditCardExpirationMonth) {
            alert('有効期限月を指定してください。');
            return false;
        }
        if (!this.phoneNumber) {
            alert('電話番号を入力してください。');
            return false;
        }
        if (!this.mailaAddress) {
            alert('メールアドレスを入力してください。');
            return false;
        } else if (!this.validEmail(this.mailaAddress)){
            alert('メールアドレスの形式に誤りがあります。');
            return false;
        }
        return true;
    }

    validEmail (email: string){
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    @Emit()
    public inputPhoneNumberEmit(inputPhoneNumber: string) {
        this.phoneNumber = inputPhoneNumber;
    }

    private get inputPhoneNumber(): string {
        return this.phoneNumber;
    }

    private set inputPhoneNumber(phoneNumber: string) {
        this.inputPhoneNumberEmit(phoneNumber);
    }

    @Emit()
    public inputMailAddressEmit(inputMailAddress: string) {
        this.mailaAddress = inputMailAddress;
    }

    private get inputMailAddress(): string {
        return this.mailaAddress;
    }

    private set inputMailAddress(mailaAddress: string) {
        this.inputMailAddressEmit(mailaAddress);
    }

    @Emit()
    public inputCreditCardNameEmit(inputCreditCardName: string) {
        this.creditCardName = inputCreditCardName;
    }

    private get inputCreditCardName(): string {
        return this.creditCardName;
    }

    private set inputCreditCardName(creditCardName: string) {
        this.inputCreditCardNameEmit(creditCardName);
    }

    @Emit()
    public inputCreditCardExpirationMonthEmit(inputCreditCardExpirationMonth: string) {
        this.creditCardExpirationMonth = inputCreditCardExpirationMonth;
    }

    private get inputCreditCardExpirationMonth(): string {
        return this.creditCardExpirationMonth;
    }

    private set inputCreditCardExpirationMonth(creditCardExpirationMonth: string) {
        this.inputCreditCardExpirationMonthEmit(creditCardExpirationMonth);
    }

    @Emit()
    public inputCreditCardExpirationYearEmit(inputCreditCardExpirationYear: string) {
        this.creditCardExpirationYear = inputCreditCardExpirationYear;
    }

    private get inputCreditCardExpirationYear(): string {
        return this.creditCardExpirationYear;
    }

    private set inputCreditCardExpirationYear(creditCardExpirationYear: string) {
        this.inputCreditCardExpirationYearEmit(creditCardExpirationYear);
    }

    @Emit()
    public inputCreditCardNumberEmit(inputCreditCardNumber: string) {
        this.creditCardNumber = inputCreditCardNumber;
    }

    private get inputCreditCardNumber(): string {
        return this.creditCardNumber;
    }

    private set inputCreditCardNumber(creditCardNumber: string) {
        this.inputCreditCardNumberEmit(creditCardNumber);
    }
}
